import React from 'react';
import {FaPhone} from "react-icons/fa";

function SquarePhoneButton(props) {
    return (
        <a href="tel:+35316854888">
            <button className='btn btn-square bg-primary text-white d-inline-flex align-items-center justify-content-center'>
                <FaPhone/>
            </button>
        </a>
    );
}

export default SquarePhoneButton;